'use client'
import { useAssistantContext } from './AssistantProvider'
import AssistantPanel from './AssistantPanel'

function FloatingButton() {
  const assistant = useAssistantContext()
  const onClick = () => assistant.toggle()
  return (
    <>
      <AssistantPanel />
      <button
        onClick={onClick}
        aria-label="Assistant"
        style={{
          position: 'fixed',
          right: 16,
          bottom: 16,
          width: 56,
          height: 56,
          borderRadius: 28,
          background: '#0ea5e9',
          color: '#ffffff',
          border: 'none',
          boxShadow: '0 8px 20px rgba(0,0,0,0.2)',
          fontSize: 18,
          cursor: 'pointer'
        }}
      >
        AI
      </button>
    </>
  )
}

export default FloatingButton
export { FloatingButton as AssistantFloatingButton }
